export const fetchBic = (setFormData: (x: any) => void, formData: any) => {
  if (
    formData.bankAccountNumber.length === 19 ||
    formData.bankAccountNumber.length === 16
  ) {
    const data = fetch(
      "https://openiban.com/validate/" +
        formData.bankAccountNumber.split(" ").join("") +
        "?getBIC=true"
    )
      .then((x) => x.json())
      .then((y) => {
        const bic = y?.bankData?.bic;
        if (bic) {
          setFormData({ ...formData, bic });
        } else {
          setFormData({ ...formData, bic: "" });
        }
      });
  } else if (
    formData.bankAccountNumber.length < 19 &&
    formData.bankAccountNumber.length > 0
  ) {
    setFormData({ ...formData, bic: "" });
  }
};
